export const FIRST_NAME_REQUIRED =
  'Please enter the first name of the student.';
export const LAST_NAME_REQUIRED = 'Please enter the last name of the student.';
export const CLASS_ID_REQUIRED = 'Please select the class for student.';
export const BRANCH_ID_REQUIRED = 'Please select the branch for student.';
export const DOB_REQUIRED = 'Please enter the date of birth of the student.';
export const GENDER_REQUIRED = 'Please select the gender of the student.';
